import TaskManagerList from "./components/TaskManagerList.vue";
import TaskManagerView from "./components/TaskManagerView.vue";
import TaskManagerEditPage from "./pages/TaskManagerEditPage.vue";

export default {
    TaskManagerList,
    TaskManagerView,
    TaskManagerEditPage,
};
